
const checkUtils = {};

// 类型校验
function buildTypeChecker() {
  const types = ['Number', 'String', 'Function', 'Undefined', 'Boolean', 'Object', 'Array'];
  types.forEach((type) => {
    checkUtils[`is${type}`] = function (value) {
      const typeName = `[object ${type}]`;
      return typeName === Object.prototype.toString.call(value);
    };
  });
}
/**
 * 对象遍历
 */
export function forIn(obj, callback) {
  if (obj) {
    Object.entries(obj).forEach((entry) => {
      callback(...entry);
    });
  }
}
// exports.forIn = forIn;
/**
 * 已有属性覆盖和未有属性添加
 * @param dest destination object
 * @param {...Object} sources sources from which properties are pulled
 * @private
 */
export function extend(dest, ...sources) {
  for (const src of sources) {
    forIn(src, (key, value) => {
      // eslint-disable-next-line no-param-reassign
      dest[key] = value;
    });
  }
  return dest;
};
/**
 * Determine if a string ends with a particular substring
 *
 * @private
 */
export function endsWith(string, suffix) {
  return string.indexOf(suffix, string.length - suffix.length) !== -1;
};
/**
 * 生成一个唯一id
 * @returns unique numeric id.
 * @private
 */
const uniqueId = (function () {
  // return idHead + id++;

  // http://www.broofa.com/Tools/Math.uuid.htm

  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = new Array(36);
  let rnd = 0; let r;

  return function generateUUID() {
    for (let i = 0; i < 36; i ++) {
      if (i === 8 || i === 13 || i === 18 || i === 23) {
        uuid[i] = '-';
      } else if (i === 14) {
        uuid[i] = '4';
      } else {
        if (rnd <= 0x02) {
          rnd = 0x2000000 + (Math.random() * 0x1000000) | 0;
        }
        r = rnd & 0xf;
        rnd = rnd >> 4;
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }

    return uuid.join('');
  };
}());

buildTypeChecker(checkUtils);

function checkParamTypes(checkObj, checkOptions) {
  const keys = Object.keys(checkOptions);
  const res = {
    checkSuccess: true,
    checkFailParam: '',
  };
  keys.forEach((key) => {
    if (!checkOptions[key](checkObj[key])) {
      res.checkSuccess = false;
      res.checkFailParam = key;
    }
  });

  return res;
}
/**
 * 是否是iOS13以下手机
 */
function isLowIOSDevice() {
  const ua = self.navigator.userAgent;
  try {
    const iOSV = (ua.includes('iPhone') || ua.includes('iPad') || ua.includes('iPod')) && (ua.match(/OS ((\d+_?){2,3})\s/) && parseFloat(String(ua.match(/OS ((\d+_?){2,3})\s/)[1]).replace('_', '.')));
    if (iOSV && iOSV < 13.0) {
      console.log('iosV', iOSV);
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export { checkUtils, checkParamTypes, uniqueId, isLowIOSDevice };
